import { Collapse, Divider, List, useTheme, alpha, Box } from "@mui/material";
import React from "react";

import { SidebarMenuItemButton } from "./SidebarMenuItemButton";
import { SidebarMenuItems } from "./SidebarMenuItems";
import type { SidebarMenuItemRowProps } from "./types";
import { sidebarTheme } from "@/styles/sidebarTheme";

export const SidebarMenuItemRow: React.FC<SidebarMenuItemRowProps> = React.memo(
  (props) => {
    const { item, openItems, level = 0, selectedItem } = props;

    const theme = useTheme();
    const hasChildren = !!item.items?.length;
    const isExpanded = !!openItems[item.text];
    const isSelected = selectedItem === item.text;

    return (
      <Box
        sx={{
          mb: level === 0 ? 1 : 0,
        }}
      >
        {item.startsWithDivider && (
          <Divider
            sx={{
              my: theme.spacing(2),
              mx: theme.spacing(2),
              borderColor: alpha(theme.palette.divider, 0.2),
              borderWidth: 1,
              position: "relative",
              "&:before": {
                content: '""',
                position: "absolute",
                left: "50%",
                top: "50%",
                transform: "translate(-50%, -50%)",
                width: "60%",
                height: "100%",
                background: `linear-gradient(90deg, transparent 0%, ${alpha(
                  theme.palette.primary.main,
                  0.1
                )} 50%, transparent 100%)`,
              },
            }}
          />
        )}
        <SidebarMenuItemButton {...props} />
        {hasChildren && (
          <Collapse
            in={isExpanded}
            timeout={{
              enter: 300,
              exit: 200,
            }}
            unmountOnExit
          >
            <List
              component="div"
              disablePadding
              sx={{
                mt: 0.5,
                position: "relative",
                "&:before": {
                  content: '""',
                  position: "absolute",
                  left: theme.spacing(3),
                  top: 0,
                  bottom: 0,
                  width: "2px",
                  background: isSelected
                    ? sidebarTheme.menu.selected.verticalLine
                    : sidebarTheme.menu.normal.verticalLine,
                  borderRadius: "1px",
                },
              }}
            >
              <SidebarMenuItems
                {...props}
                items={item.items!}
                level={level + 1}
              />
            </List>
          </Collapse>
        )}
      </Box>
    );
  }
);
